import { environment } from '../assets/environment';
import { Injectable } from '@angular/core';

const defaultd = environment.defaultValue;

enum LocalStorageKey {
  PORTFOLIO_ID = 'PortfolioId',
  PORTFOLIO_CODE = 'PortfolioCode',
  CLIENT_ID = 'ClientId',
  CLIENT_CODE = 'ClientCode',
  DOMAIN = 'Domain',
  LANGUAGE = 'Language',
  SESSION_TOKEN = 'SessionClientToken',
  TOKEN = 'Token',
  USER_CODE = 'UserCode',
  CRITERIA_NLP_ID = 'CriteriaNlpId',
  CRITERIA_NLP_NAME = 'CriteriaNlpName',
  ACTIVE_MINIMAL = 'ActiveMinimal',
  FORMATS = 'FormatsTech',
  CONDITIONAL_FORMATS = 'ConditionalFormats',
  GROUP_SEPARATOR = 'GroupSeparator',
  DATE_FORMAT = 'DateFormat',
  DECIMAL_SEPARATOR = 'DecimalSeparator',
  NEGATIVE_SYMBOL = 'NegativeSymbol',
  NUMBER_OF_DECIMAL = 'NumberOfDecimal',
}

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private _portfolioId: string = undefined;
  private _portfolioCode: string = undefined;
  private _clientCode: string = undefined;
  private _clientId: string = undefined;
  private _domain: string = undefined;
  private _language: string = undefined;
  private _sessionToken: string = undefined;
  private _token: string = undefined;
  private _userCode: string = undefined;
  private _criteriaNlpId: string = undefined;
  private _criteriaNlpName: string = undefined;
  private _activeMinimal: boolean = undefined;

  private _formats: [] = undefined;
  private _conditionalFormats: object = undefined;
  private _group_separator: string = undefined;
  private _date_format: string = undefined;
  private _decimal_separator: string = undefined;
  private _negative_symbol: string = undefined;
  private _number_of_decimal: any = undefined;

  get groupSeparator(): string | undefined {
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.GROUP_SEPARATOR)
    ) {
      this._group_separator = window.localStorage.getItem(
        LocalStorageKey.GROUP_SEPARATOR
      );
    } else {
      this._group_separator = defaultd.GroupSeparator;
    }
    return this._group_separator;
  }

  get dateFormat(): string | undefined {
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.DATE_FORMAT)
    ) {
      this._date_format = window.localStorage.getItem(
        LocalStorageKey.DATE_FORMAT
      );
    } else {
      this._date_format = defaultd.DateFormat;
    }
    return this._date_format;
  }

  get decimalSeparator(): string | undefined {
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.DECIMAL_SEPARATOR)
    ) {
      this._decimal_separator = window.localStorage.getItem(
        LocalStorageKey.DECIMAL_SEPARATOR
      );
    } else {
      this._decimal_separator = defaultd.DecimalSeparator;
    }
    return this._decimal_separator;
  }

  get negativeSymbol(): string | undefined {
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.NEGATIVE_SYMBOL)
    ) {
      this._negative_symbol = window.localStorage.getItem(
        LocalStorageKey.NEGATIVE_SYMBOL
      );
    } else {
      this._negative_symbol = defaultd.NEGATIVE_SYMBOL;
    }
    return this._negative_symbol;
  }

  get numberOfDecimal(): number | undefined {
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.NUMBER_OF_DECIMAL)
    ) {
      this._number_of_decimal = window.localStorage.getItem(
        LocalStorageKey.NUMBER_OF_DECIMAL
      );
    } else {
      this._number_of_decimal = defaultd.NUMBER_OF_DECIMAL;
    }
    return this._number_of_decimal;
  }

  get formats(): [] {
    let cc: string;
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.FORMATS)
    ) {
      cc = window.localStorage.getItem(LocalStorageKey.FORMATS);
    } else {
      cc = defaultd.formatsTech;
    }
    this._formats = JSON.parse(cc);

    return this._formats;
  }

  get conditionalFormats(): object {
    let cc: string;
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.CONDITIONAL_FORMATS)
    ) {
      cc = window.localStorage.getItem(LocalStorageKey.CONDITIONAL_FORMATS);
    } else {
      cc = defaultd.conditionalFormats;
    }
    this._conditionalFormats = JSON.parse(cc);

    return this._conditionalFormats[0];
  }

  get language(): string | undefined {
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.LANGUAGE)
    ) {
      this._language = window.localStorage.getItem(LocalStorageKey.LANGUAGE);
      //window.localStorage.removeItem(LocalStorageKey.LANGUAGE);
    } else {
      this._language = defaultd.language;
    }

    return this._language;
  }

  get sessionToken(): string | undefined {
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.SESSION_TOKEN)
    ) {
      this._sessionToken = window.localStorage.getItem(
        LocalStorageKey.SESSION_TOKEN
      );
    } else {
      this._sessionToken = defaultd.sessionToken;
    }

    return this._sessionToken;
  }

  get userCode(): string | undefined {
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.USER_CODE)
    ) {
      this._userCode = window.localStorage.getItem(LocalStorageKey.USER_CODE);
    } else {
      this._userCode = defaultd.userCode;
    }

    return this._userCode;
  }

  get domain(): string | undefined {
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.DOMAIN)
    ) {
      this._domain = window.localStorage.getItem(LocalStorageKey.DOMAIN);
    } else {
      this._domain = defaultd.domain;
    }

    return this._domain;
  }

  get clientCode(): string | undefined {
    if (
      window.localStorage &&
      window.localStorage.getItem(LocalStorageKey.CLIENT_CODE)
    ) {
      this._clientCode = window.localStorage.getItem(
        LocalStorageKey.CLIENT_CODE
      );
    } else {
      this._clientCode = defaultd.clientCode;
    }

    return this._clientCode;
  }
  /**
   * Getter $portfolioCode
   * @return {PortfolioCode}
   */
  get portfolioCode(): string | undefined {
    if (!this._portfolioCode) {
      if (
        window.localStorage &&
        window.localStorage.getItem(LocalStorageKey.PORTFOLIO_CODE)
      ) {
        this._portfolioCode = window.localStorage.getItem(
          LocalStorageKey.PORTFOLIO_CODE
        );
      } else {
        this._portfolioCode = defaultd.portfolioCode;
      }
    }
    return this._portfolioCode;
  }

  /**
   * Setter $portfolioCode
   * @parameter {portfolioCode}
   */

  set portfolioCode(value: string) {
    this._portfolioCode = value;
  }

  /**
   * Getter $clientId
   * @return {string}
   */
  get clientId(): string | undefined {
    if (!this._clientId) {
      if (
        window.localStorage &&
        window.localStorage.getItem(LocalStorageKey.CLIENT_ID)
      ) {
        this._clientId = window.localStorage.getItem(LocalStorageKey.CLIENT_ID);
      } else {
        this._clientId = defaultd.clientId;
      }
    }
    return this._clientId;
  }

  /**
   * Setter $clientId
   * @parameter {string}
   */
  set clientId(value: string) {
    this._clientId = value;
  }

  /**
   * Setter $sessionToken
   * @parameter {string}
   */
  set sessionToken(value: string) {
    this._sessionToken = value;
  }
}
